module.exports = __webpack_public_path__ + "media/images/requisitions/success-1439458112f989f1f7dd50d6afdef5c3.png";